/**
 * The dashboards' routes — v19 D3.
 *
 * ONE route: `group`, the group-consolidated view. It is mounted under
 * `/countries/:cc/group` like every other screen (there is no top-level route precedent —
 * the global admin surfaces live there too, `nav.ts`), but it is a GLOBAL surface: the API
 * route carries no `:cc`, the nav row carries `global: true`, and the screen ignores the
 * country in the URL for everything except where the shell is standing.
 *
 * The country dashboard has NO route of its own: it EXTENDS the index `DashboardPage`
 * (`features/dashboard/DashboardPage.tsx` mounts `CountryDashboardSections`), which is
 * the screen the brief's D3 describes and the Figma header's period chips were parked for.
 */

import type { RouteObject } from 'react-router-dom';

import { GroupDashboardPage } from './GroupDashboardPage';

export const dashboardsRoutes: RouteObject[] = [{ path: 'group', element: <GroupDashboardPage /> }];
